import React from 'react';

import {Field, Form, FormikProps} from 'formik';
import {Box, Grid, Typography} from '@material-ui/core';
import {EfeFieldText, EfeButtonPrimary, EfeErrorMsg, EfeRadioGroup} from 'components';
import {ConsigneeTerms} from 'commons/types/Types';
import {CallMade} from '@material-ui/icons';
import {ConsigneeRadioValues} from 'commons/constants';

const OPTIONS = [
    {
        id: ConsigneeRadioValues.TRUE,
        value: 'Si',
        order: 0,
        status: 'A',
    },
    {
        id: ConsigneeRadioValues.FALSE,
        value: 'No',
        order: 1,
        status: 'A',
    },
];

export default function ConsigneeInnerForm(props: FormikProps<ConsigneeTerms>) {
    const {values, errors, isSubmitting, setFieldValue} = props;

    function handleRadioChange(name: string, value: boolean) {
        if ('hasConsignees' === name && !value) {
            setFieldValue('numberConsignees', '');
            setFieldValue('hasAdminAccounts', false);
        } else if ('hasAdminAccounts' === name && !value) {
            setFieldValue('numberConsignees', '');
        }
        setFieldValue(name, value);
    }

    function handleTextChange(event: React.ChangeEvent<{value: unknown}>) {
        setFieldValue('numberConsignees', event.target.value);
    }

    return (
        <Form noValidate>
            <Box m={2}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Field
                            type='radioGroup'
                            component={EfeRadioGroup}
                            label={'¿Cuentas con Consignatarios?'}
                            fieldName={'hasConsignees'}
                            options={OPTIONS}
                            value={`${values.hasConsignees}`}
                            inlineRadio={true}
                            labelPlacement={'top'}
                            radioLabelPlacement={'start'}
                            change={(event: React.ChangeEvent<HTMLInputElement>) =>
                                handleRadioChange(
                                    'hasConsignees',
                                    ConsigneeRadioValues.TRUE === event.target.value
                                )
                            }
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Field
                            type='radioGroup'
                            component={EfeRadioGroup}
                            label={
                                '¿Vas a requerir una cuenta de administraci\u00F3n por cada uno de estos consignatarios?'
                            }
                            fieldName={'hasAdminAccounts'}
                            options={OPTIONS}
                            value={`${values.hasAdminAccounts}`}
                            inlineRadio={true}
                            labelPlacement={'top'}
                            disabled={!values.hasConsignees}
                            radioLabelPlacement={'start'}
                            size={'medium'}
                            helpIcontext={
                                '(Es decir, que cada administrador por consignatario tenga un usuario en el sistema de administraci\u00F3n y designe sus propios tarjetahabientes)'
                            }
                            change={(event: React.ChangeEvent<HTMLInputElement>) =>
                                handleRadioChange(
                                    'hasAdminAccounts',
                                    ConsigneeRadioValues.TRUE === event.target.value
                                )
                            }
                        />
                    </Grid>
                </Grid>

                <>
                    <Grid container spacing={2} justifyContent={'space-between'}>
                        <Grid item xs={12}>
                            <Typography component={'span'} variant='h5'>
                                De esos consignatarios, ¿Cu&aacute;ntos requieres con una cuenta de
                                administraci&oacute;n adicional?
                            </Typography>
                            <EfeFieldText
                                fullWidth
                                required={true}
                                key={'field-numberConsignees'}
                                id={'numberConsignees'}
                                name={'numberConsignees'}
                                label={''}
                                value={values.numberConsignees}
                                onChange={handleTextChange}
                                disabled={!values.hasConsignees || !values.hasAdminAccounts}
                                error={!!errors.numberConsignees}
                                type={'number'}
                            />
                            {errors.numberConsignees && (
                                <EfeErrorMsg message={errors.numberConsignees} />
                            )}
                        </Grid>
                    </Grid>
                    <Typography component={'span'} variant='subtitle1'>
                        <Grid item xs={12}>
                            <Grid container spacing={2} justifyContent={'center'}>
                                **Por cada Cuenta de administraci&oacute;n adicional
                                (consignatario), deber&aacute;s firmar un contrato con
                                Efectifintech.
                            </Grid>
                        </Grid>
                    </Typography>

                    <Grid container direction='row' justifyContent='flex-end'>
                        <Box pt={6} width={160}>
                            <EfeButtonPrimary
                                fullWidth
                                disabled={isSubmitting}
                                type='submit'
                                endIcon={<CallMade />}>
                                {'OK'}
                            </EfeButtonPrimary>
                        </Box>
                    </Grid>
                </>
            </Box>
        </Form>
    );
}
